import { AdminPage } from "./features/admin/AdminPage";
import { ComposerPage } from "./features/composer/ComposerPage";
import { HomePage } from "./features/home/HomePage";

export function App() {
  if (location.pathname === "/") return <HomePage />;
  if (location.pathname === "/admin") return <AdminPage />;
  return <ComposerPage />;
}
